const config = {
  ENVIRONMENT_NAME: 'prod',
  forwoodId: {
    URL: 'https://id.datainsights.forwoodsafety.com',
    USER_TOKEN_URL: 'https://qhb0cq0ds9.execute-api.us-west-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://qsa2km3g6g.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'teams-container-1.11.7',
    HOSTNAME: 'https://teams.datainsights.forwoodsafety.com',
    TEAMS_MICROFRONTEND_URL: 'https://teams-service.datainsights.forwoodsafety.com',
    TARGETS_MICROFRONTEND_URL: 'https://targets.datainsights.forwoodsafety.com',
    TEAMS_ACCESS_ROLE: 'TeamsAccess',
    TEAM_TARGETS_ACCESS_ROLE: 'TeamTargetsAccess',
  },
  configurationService: {
    URL: 'https://config.datainsights.forwoodsafety.com',
    WEBSOCKET: 'wss://dnjv875rxk.execute-api.us-west-2.amazonaws.com/prod'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
